import { createContext, useState } from "react";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState({
    user: localStorage.getItem("usertokens") || "",
    hamyar: localStorage.getItem("hamyartokens") || "",
  });
  // const [panelType,setPanelType]=useState("")
  const setTokens = (panelType, data) => {
    // console.log("Setting token for panelType:", panelType);

    if (panelType === "user") {
      localStorage.setItem("usertokens", data);
      setAuth((prevTokens) => ({
        ...prevTokens,
        user: data,
      }));
    } else if (panelType === "hamyar") {
      localStorage.setItem("hamyartokens", data);
      setAuth((prevTokens) => ({
        ...prevTokens,
        hamyar: data,
      }));
    } else {
      console.log("Unexpected panelType:", panelType);
    }
  };
  return (
    <AuthContext.Provider value={{ auth, setAuth: setTokens }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
